import { CTASection } from "../shared/cta-section";

export const CTA = () => {
  return (
    <CTASection
      id="ausenv-cta"
      title="Experience continental-scale environmental analytics"
      description="See how Terrak.io transformed Australia's environmental monitoring from supercomputer dependency to on-demand analytics. Explore the interactive environmental data platform powering Australia's Environment Report."
      buttons={[
        {
          text: "Explore Australia's Environment Report",
          href: "https://ausenv.tern.org.au/",
          backgroundColorClass: "bg-haizea-green",
        },
        {
          text: "Learn About Terrak.io",
          href: "https://terrak.io/",
          backgroundColorClass: "bg-haizea-blue",
        },
      ]}
    />
  );
};
